import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResourceEmailComponent } from '../../components/resource-email/resource-email.component';
import { FilterPipe } from 'ngx-filter-pipe';
import { FilterResourcesPipe } from '../../pipes/filter-resources/filter-resources.pipe';
import { RichTextEditorComponent } from 'src/app/shared/components/rich-text-editor/rich-text-editor.component';
import { FormsModule } from '@angular/forms';
import { PopoverModule } from 'ngx-bootstrap/popover';

@NgModule({
    exports: [
        ResourceEmailComponent
    ],
    declarations: [
        ResourceEmailComponent,
        FilterResourcesPipe
    ],
    imports: [
        CommonModule,
        RichTextEditorComponent,
        FormsModule,
        PopoverModule
    ]
})
export class ResourceEmailModule { }
